import React from 'react'
import PropTypes from 'prop-types'
import { configure } from 'label-insight-app-shell'
import CoreLayout from '../layouts/CoreLayout/CoreLayout'
import workflowRoute from './Workflow'
import buttonRoute from './Button'
import offPackageLoaderRoute from './OffPackageLoader'
import bulkIngredientToggleRoute from './BulkIngredientToggle'
import bulkAddClaimsRoute from './BulkAddClaims'
import rebuildElasticsearchDataRoute from './RebuildElasticsearchData'
import defaultEditRoute from './DefaultEdit'
import labelSyncConfigRoute from './LabelSyncConfig'
import additionalLinksRoute from './AdditionalLinks'

const Home = () => (
  <div>
    <p>Select an option from the menu</p>
  </div>
)

export const createRoutes = (store) => {
  const config = {
    appId: 'verification-dashboard',
    onFullyAuthenticated(router, redirectPath) {
      if (redirectPath) {
        router.push(redirectPath)
      }
    },
    initialAppShellUiState: {
      showSearch: false,
      isInternal: true,
      showHeader: false
    }
  }

  const { routeHooks, routes, Shell } = configure(store, config)

  const RootComponent = ({ children, ...props }) => (
    <Shell {...props}>
      <CoreLayout>
        {children}
      </CoreLayout>
    </Shell>
  )

  RootComponent.propTypes = {
    children: PropTypes.node
  }

  return {
    path: '/',
    component: RootComponent,
    indexRoute: {
      component: Home,
      onEnter: routeHooks.root
    },
    childRoutes: [
      ...routes,
      workflowRoute(store, routeHooks.requireAuth),
      buttonRoute(store, routeHooks.requireAuth),
      offPackageLoaderRoute(store, routeHooks.requireAuth),
      bulkIngredientToggleRoute(store, routeHooks.requireAuth),
      bulkAddClaimsRoute(store, routeHooks.requireAuth),
      rebuildElasticsearchDataRoute(store, routeHooks.requireAuth),
      defaultEditRoute(store, routeHooks.requireAuth),
      labelSyncConfigRoute(store, routeHooks.requireAuth),
      additionalLinksRoute(store, routes.requireAuth)
    ]
  }
}

export default createRoutes



// WEBPACK FOOTER //
// ./src/routes/index.js